import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, setAdminToken } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      setAdminToken(res.data.token);
      toast.success("Bienvenue Cindy.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Identifiants incorrects.");
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-sand-50 flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full max-w-md"
      >
        <Link to="/" className="block text-center mb-2" data-testid="brand-logo">
          <img
            src="https://static.wixstatic.com/media/af9b25_f36f1ab2bff848758e1745acea6e006c~mv2.png/v1/fill/w_400,h_236,al_c,q_85,enc_avif,quality_auto/eclaire_toi_texte_et_main.png"
            alt="Éclaire-Toi"
            className="mx-auto h-20 w-auto"
          />
        </Link>
        <p className="text-center text-xs uppercase tracking-[0.32em] text-sand-500 mb-10">
          Espace admin
        </p>

        <div className="rounded-3xl border border-sand-200 bg-white p-8 shadow-soft">
          <h1 className="font-serif text-3xl text-ink">Connexion</h1>
          <p className="mt-2 text-sm text-ink-soft">
            Accédez à vos diagnostics et restitutions.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div>
              <label className="block text-sm font-medium text-ink-soft mb-2 ml-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-xl border border-sand-200 bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sand-300 focus:border-sand-500 transition"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-ink-soft mb-2 ml-1">Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-xl border border-sand-200 bg-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-sand-300 focus:border-sand-500 transition"
                data-testid="admin-password-input"
              />
            </div>
            <div className="flex justify-center pt-3">
              <button
                type="submit"
                disabled={loading}
                className="group inline-flex items-center gap-3 rounded-full bg-sand-500 hover:bg-sand-600 text-white pl-7 pr-2 py-2 shadow-soft transition-all duration-500 hover:shadow-elevated disabled:opacity-50 whitespace-nowrap"
                data-testid="admin-login-btn"
              >
                <span className="text-sm font-medium tracking-wide leading-none">
                  {loading ? "Connexion en cours" : "Se connecter"}
                </span>
                <span
                  aria-hidden
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 transition-all duration-500 group-hover:bg-white group-hover:text-sand-500 group-hover:rotate-[-12deg] text-sm"
                >
                  →
                </span>
              </button>
            </div>
          </form>
        </div>
        <Link
          to="/"
          className="mt-8 block text-center text-xs uppercase tracking-[0.22em] text-ink-muted hover:text-ink"
        >
          ← Retour au site
        </Link>
      </motion.div>
    </div>
  );
}
